import React from "react";
import {
  Container,
  Content,
  Image,
  ImageContainer,
  SubTitle,
  Title,
  ViewContent,
} from "./styles";

function MenuCard({ data }) {
  if (!data) {
    return null;
  }

  return (
    <Container>
      <ImageContainer>
        <Image src={data.imgSrc} alt="Illustration" />
      </ImageContainer>
      <Content>
        <Title>{data.title}</Title>
        <SubTitle>{data.description}</SubTitle>
        <ViewContent
          href={data.buttonLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.buttonLabel}
        </ViewContent>
      </Content>
    </Container>
  );
}

export default MenuCard;
